/* Ссылки внутри текстов информационных страниц проставляются автоматически, чтобы контент оставался обычными строками. */
const LINK_PATTERN = /(https?:\/\/[^\s,;)]*[^\s,;.)]|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;

export const renderRichText = text =>
  String(text)
    .split(LINK_PATTERN)
    .map((part, index) => {
      if (index % 2 === 0) return part;

      const isUrl = part.startsWith("http");

      return (
        <a
          key={`link-${index}`}
          href={isUrl ? part : `mailto:${part}`}
          target={isUrl ? "_blank" : undefined}
          rel={isUrl ? "noreferrer" : undefined}
        >
          {part}
        </a>
      );
    });
